import type { AppDefinition } from '../../../../types/apps';

/**
 * Medication Table Creator — an entity-backed physician app.
 *
 * Unlike the stateless physician widgets (CrCl, ICD-10, …) this app owns a
 * persisted `MedicationTable` entity (skeleton.model = the full table model)
 * and routes through the entity-type registry (appType `medtable`). It is still
 * surfaced in the Physician Toolbox and dock under the `phys-medtable` appId so
 * it shares the physician squircle styling and provisioning.
 */
const medicationTableDefinition: AppDefinition = {
  appId: 'phys-medtable',
  name: 'Medication Table',
  version: '1.0.0',
  description:
    'Create beautiful, printable medication tables and schedules. Templates, branding, multi-language, PDF/print export, and an AI double-check against RxNorm + interactions.',

  entityTypes: ['MedicationTable'],
  requiresEntity: true,
  requiresProps: false,

  component: 'medtable',

  searchableSkeletonFields: {
    MedicationTable: ['title', 'language'],
  },

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'Pill',
    phosphorWeight: 'duotone' as const,
    metadata: {
      source: 'app' as const,
      appId: 'phys-medtable',
      isAppIcon: true,
    },
  },

  agenticToolIds: ['medication_table'],
  features: [],
  category: 'physician',
  isCore: false,
  isSystem: true,
  experimental: true,
};

export default medicationTableDefinition;
